import { CalendarAddAlt } from "@carbon/icons-react";
import { ListItemText } from "@mui/material";
import { t } from "i18next";
import moment from "moment";

import { InboundDeliveryItemFragment } from "../../../../models/autogenerated-deliveryService-gql/graphql";
import { TimeSlotBooking } from "../../../../models/timeSlotBooking";
import { formattedTimeSlotString } from "../../../../utils/helper";
import {
  mapToIDeliveryItem,
  mapToIDeliveryItems,
} from "../../../../utils/mapper";
import CheckBoxItemList from "../../../checkboxItemList/CheckBoxItemList";
import CheckBoxItemListItem from "../../../checkboxItemList/CheckBoxItemListItem";

const buildCheckBoxOptions = (
  inboundDeliveryItems: InboundDeliveryItemFragment[],
) => {
  let timeSlotBookings: TimeSlotBooking[] = [];
  if (inboundDeliveryItems.length === 0) return timeSlotBookings;

  //we need to group the deliveryItems by timeSlotId, so we create a VierwModel "TimeSlotBooking"
  inboundDeliveryItems.forEach((item) => {
    if (item.__typename !== "MaterialItem" || !item.timeSlotResolved) return;

    const existingBookingIndex = timeSlotBookings.findIndex(
      (booking) => booking.timeSlotId === item.timeSlotResolved?.timeSlotId,
    );

    //if the booking does not exist, we create a new one
    if (existingBookingIndex === -1) {
      const deliveryItems = mapToIDeliveryItems([item]);

      timeSlotBookings.push({
        timeSlotId: item.timeSlotResolved?.timeSlotId,
        start: item.timeSlotResolved?.start,
        end: item.timeSlotResolved?.end,
        deliveryItems: deliveryItems,
      });
      return;
    }

    //if the booking exists, we add the deliveryItem to the existing booking
    const deliveryItem = mapToIDeliveryItem(item);
    if (deliveryItem)
      timeSlotBookings[existingBookingIndex].deliveryItems.push(deliveryItem);
  });

  return timeSlotBookings;
};

interface CheckBoxListTimeSlotBookingsProps {
  inboundDeliveryItems: InboundDeliveryItemFragment[];
  selectedOptions: TimeSlotBooking[];
  onCheckBoxChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    option: TimeSlotBooking,
  ) => void;
}

const CheckBoxListTimeSlotBookings = (
  props: CheckBoxListTimeSlotBookingsProps,
) => {
  const { inboundDeliveryItems, selectedOptions, onCheckBoxChange } = props;

  const options = buildCheckBoxOptions(inboundDeliveryItems);

  return (
    <CheckBoxItemList listCount={options.length}>
      {options.map((option, index) => {
        const dateString = moment(new Date(option.start))
          .locale(t("locale"))
          .format(t("dateFormat"));
        const timeSlotString = formattedTimeSlotString(
          option.start,
          option.end,
        );

        return (
          <CheckBoxItemListItem
            key={index}
            item={option}
            icon={<CalendarAddAlt className="list-item-icon" size={24} />}
            checked={selectedOptions.some(
              (selectedOption) =>
                option.timeSlotId === selectedOption.timeSlotId,
            )}
            handleChange={onCheckBoxChange}
          >
            <ListItemText
              sx={{ wordBreak: "break-all" }}
              primary={`${dateString} ${timeSlotString}`}
              secondary={`${t("materialPosition")}: ${option.deliveryItems.map((item) => item.position).join(", ")}`}
            />
          </CheckBoxItemListItem>
        );
      })}
    </CheckBoxItemList>
  );
};
export default CheckBoxListTimeSlotBookings;
